import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import { IOffer } from '../../models/offers'

export const useOffersModalGeneralTab = (offerState: IOffer, setOfferState: Dispatch<SetStateAction<IOffer>>) => {
  const { t } = useTranslation(['global'])
  const { roles } = useSelector((state: IRootState) => state.role)
  const { countries } = useSelector((state: IRootState) => state.country)
  const { languages } = useSelector((state: IRootState) => state.language)

  const types = [
    { id: 0, name: t('professional') },
    { id: 1, name: t('common.client') }
  ]

  const status = [
    { id: 0, name: t('active') },
    { id: 1, name: t('inactive') }
  ]

  const visibility = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') }
  ]

  const handleAutoCompleteChange = (inputName: string) => async (_event: any, value: any) => {
    setOfferState({ ...offerState, [inputName]: value })
  }

  const handleNumberChange = (inputName: string) => (_event: any, value: any) => {
    if (value != null) setOfferState({ ...offerState, [inputName]: value.id })
    else setOfferState({ ...offerState, [inputName]: value })
  }

  const getUploadParams =
    (type: number) =>
    ({ meta }: any) => {
      let tmpFileNames = [...offerState.filesNames]
      tmpFileNames.push({ name: meta.name, type })
      setOfferState({ ...offerState, filesNames: tmpFileNames })
      return { url: `${import.meta.env.VITE_API_URL}/offers/upload/${meta.name}` }
    }

  const removeFileDropzone = (type: number) => (index: number) => {
    const copyFilesNames = [...offerState.filesNames]
    const filesNamesOfType = copyFilesNames.filter(file => file.type === type)
    const filesNamesNotType = copyFilesNames.filter(file => file.type !== type)
    filesNamesOfType.splice(index, 1)
    setOfferState({ ...offerState, filesNames: [...filesNamesOfType, ...filesNamesNotType] })
  }

  return {
    roles,
    countries,
    languages,
    types,
    status,
    visibility,
    handleAutoCompleteChange,
    handleNumberChange,
    getUploadParams,
    removeFileDropzone
  }
}
